export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vecchia password"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuova password"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma password"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salva"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"Nuova password\" e \"Conferma password\" non coincidono."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cambio password"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stringa da 4 a 63 caratteri. Sono ammessi caratteri dell'alfabeto latino, numeri e simboli"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vuoto"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Debole"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Medio"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forte"])}
  }
}